import { render, staticRenderFns } from "./EditResolutionsCatalog.vue?vue&type=template&id=b44d3426&"
import script from "./EditResolutionsCatalog.vue?vue&type=script&lang=js&"
export * from "./EditResolutionsCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports